import React from "react";
import HomeCard from "./HomeCard";
import { Link } from "react-router-dom";
import RequireData from "hooks/RequireData";
import filesSelector from "selectors/files";
import filesStatusSelector from "selectors/filesStatus";
import { fetchFiles } from "actions/file";

const FilesCard: React.FC = () => {
    const [files, status] = RequireData(
        filesSelector(0),
        filesStatusSelector(0),
        fetchFiles(0)
    );
    return (
        <HomeCard>
            <h5 className="card-title">Most Recent File</h5>
            {status === "error" && <p>Error loading files</p>}
            {status === "loading" && <p>Loading...</p>}
            {status === "none" && !files && <p>No Files</p>}
            {status === "none" && files && files[0] && (
                <p>{files[0].friendly_name || "Unnamed File"}</p>
            )}
            <Link to="/home/files">View All Files</Link>
        </HomeCard>
    );
};

export default FilesCard;
